const testimonials = {
  label: 'What people say',
};

export default testimonials;
